import { Injectable, OnDestroy } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { FeatureToggleEnum } from '~shared/constants';
import { PageDetectionUtil } from '~shared/utils/page-detection.util';
import { Router } from '@angular/router';
import { User } from 'configcat-js-ssr';
import { CookieService } from '~shared/services/cookie.service';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { MarketDetectionUtil } from '~shared/utils/market-detection.util';

@Injectable({
  providedIn: 'root',
})
export class PlpVariantRestyleService implements OnDestroy {
  private destroySubject$: Subject<boolean> = new Subject<boolean>();

  constructor(private featureFlagService: ActiveFeaturesConfigcatService,
              private readonly router: Router,
              private cookieService: CookieService) {
  }

  ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }

  isNewPLPVariantRestyle(): Observable<boolean> {
    return of(true)
  }

  isPLP(): boolean {
    return PageDetectionUtil.isProductListPage(this.router.url);
  }
}
